import { Component, OnInit } from '@angular/core';
import { User } from '../../shared/api/model/user';
import { UserService } from '../../shared/api/resources/user/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {StaticUtils} from '../../shared/utils/static-utils';


@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  constructor(
    private _userService: UserService,
    private _route: ActivatedRoute,
    private _router: Router) { }

  ngOnInit() {
  }

  async goToUserSettings() {
    await this._router.navigateByUrl('profile');
  }

  get user(): User {
    return this._userService.user;
  }

  set user(value: User) {
    this._userService.user = value;
  }

  get userPhoto(): string {
    return this._userService.user.imagePhotoBase64 ?
      StaticUtils.prepareBase64Image(this._userService.user.imagePhotoBase64) :
      this._userService.user.imagePhoto ?
        this._userService.user.imagePhoto :
        undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/header/user/user.component.ts